import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {concatMap} from 'rxjs/operators';
import {AccessType} from '@app/modules/shared/data/constants';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';
import {WrtcService} from '@app/modules/wrtc/services/wrtc.service';
import {WebSocketService} from '@app/modules/shared/services/web-socket.service';
import {CookieService} from '@app/modules/shared/services/cookie.service';
import {LocalUser, LocalUserState} from '@app/state/local-user.state';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  public classroom: ClassroomStateModel;
  public localUser: LocalUser;

  constructor(
    private http: HttpClient,
    private store: Store,
    private wrtcService: WrtcService,
    private webSocketService: WebSocketService,
    private cookieService: CookieService
  ) {
    this.listenStoreChanges();
  }

  private listenStoreChanges(): void {
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
    });
    this.store.select(LocalUserState).subscribe((localUser: LocalUser) => {
      this.localUser = localUser;
    });
  }

  public login(loginData: {name: string; password: string}): Observable<any> {
    return this.http.post(`${this.classroom.vcrURL}/login`, loginData);
  }

  public guestLogin(user: {name: string}): Observable<any> {
    return this.http.post(`${this.classroom.vcrURL}/login/guest`, user);
  }

  public logout(isGuest = false, redirectToOAuth = false): Observable<any> {
    return this.http.post(`${this.classroom.vcrURL}/logout`, null, {params: {isGuest, redirectToOAuth}}).pipe(concatMap((result: any) => {
      this.cookieService.set('isInRoom', 'false');
      this.cookieService.delete('joinedClassId');

      const redirectToSessionEnded =
        [AccessType.TEACHER, AccessType.SUPPORT, AccessType.OBSERVER].includes(this.localUser.accessType) ||
        this.localUser.isGuest ||
        !this.classroom.currentClass;

      if (redirectToSessionEnded) {
        return of(`${window.location.href}sessionEnded`);
      }

      let redirectURL: any = this.classroom.studentPortalUrl + '#/my-class';

      if (this.classroom.currentClass?.additionalInfo?.uiVersion === 2) {
        redirectURL = this.classroom.newStudentPortalUrl;
      }

      return of(redirectURL);
    }));
  }

  public selectAccessType(accessType: AccessType): Observable<any> {
    return this.http.post(`${this.classroom.vcrURL}/login/role/${accessType}`, null);
  }
}
